import { useState } from 'react';
import axios from 'axios';

export const useEnhanceWithAI = () => {
  const [loadingMainAI, setLoadingMainAI] = useState(false);
  const [loadingIndex, setLoadingIndex] = useState<number | null>(null);

  // ✅ For decade/self-description fields
  const enhanceWithAIHandler = async (
    index: number,
    currentDecadeField: any[],
    setCurrentDecadeField: (fields: any[]) => void,
    retries = 3
  ) => {
    // Set loading state for this specific field
    const updatedFields = [...currentDecadeField];
    updatedFields[index] = { ...updatedFields[index], loadingAI: true };
    setCurrentDecadeField(updatedFields);

    try {
      const message = encodeURIComponent(currentDecadeField[index].value || '');
      const response = await axios.get(`/api/generate/sentence`, {
        params: { message },
      });

      const updatedFieldsAfterAPI = [...updatedFields];
      updatedFieldsAfterAPI[index] = {
        ...updatedFieldsAfterAPI[index],
        value: response.data,
        loadingAI: false,
      };
      setCurrentDecadeField(updatedFieldsAfterAPI);
    } catch (error) {
      console.error('An error occurred while processing the request:', error);
      // Reset loading state on error
      const resetFields = [...updatedFields];
      resetFields[index] = { ...resetFields[index], loadingAI: false };
      setCurrentDecadeField(resetFields);

      if (retries > 0 && error.response?.status === 406) {
        console.log(`Retrying in 20 seconds... (${retries} retries left)`);
        setTimeout(() => {
          enhanceWithAIHandler(index, currentDecadeField, setCurrentDecadeField, retries - 1);
        }, 20000);
      } else {
        console.error('Max retries reached or other error occurred.');
      }
    }
  };

  // ✅ For mentee question fields
  const enhanceQuestionWithAI = async (index: number, fields: any[], setFields: (fields: any[]) => void, retries = 3) => {
    setLoadingMainAI(true);
    setLoadingIndex(index);

    try {
      const message = encodeURIComponent(fields[index]?.value || '');
      const response = await axios.get(`/api/generate/question`, {
        params: { message },
      });

      const updatedFields = [...fields];
      updatedFields[index] = { ...updatedFields[index], value: response.data };
      setFields(updatedFields);
    } catch (error) {
      console.error('An error occurred while processing the request:', error);
      if (retries > 0 && error.response?.status === 406) {
        console.log(`Retrying in 20 seconds... (${retries} retries left)`);
        setTimeout(() => {
          enhanceQuestionWithAI(index, fields, setFields, retries - 1);
        }, 20000);
      } else {
        console.error('Max retries reached or other error occurred.');
      }
    } finally {
      setLoadingMainAI(false);
      setLoadingIndex(null);
    }
  };

  return {
    loadingMainAI,
    loadingIndex,
    enhanceWithAIHandler,
    enhanceQuestionWithAI,
  };
};
